import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { CommonModalComponent } from "@modules/modals/common-modal/common-modal.component";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { changePasswordLeaveModal } from "src/app/shared/data/modalData";
import { ModalService } from "src/app/shared/services/modal.service";

export interface DeactivationGuarded {
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
  // confirm():boolean;
}

@Injectable({
  providedIn: "root",
})
export class ConfirmationGuard implements CanDeactivate<DeactivationGuarded> {
  private readonly status: boolean = false;

  constructor(
    private readonly modalService: ModalService,
    private readonly store: Store,
  ) {}

  public canDeactivate(
    component: DeactivationGuarded,
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise<boolean>((resolve, reject) => {
      if (component["formDirty"] && !component["success"]) {
        this.modalService.openDialogWithCallbackHandler(
          CommonModalComponent,
          changePasswordLeaveModal,
          (response) => {
            try {
              resolve(response);
            } catch (error) {
              reject(error);
            }
          },
        );
      } else {
        resolve(true);
      }
    });
  }
}
